export default __webpack_public_path__ + "static/media/Guisarme of the Bastion.e543dea9.jpg";